// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__4Lgdb","header":"ClearentDisclaimer_header__2Id5p","inner":"ClearentDisclaimer_inner__39pHc"};